// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J6QN","title":"styles_title__33ww-"};